let id = 1;

export default function generateId(prefix, suffix) {
  return (prefix || '') + id++ + (suffix || '');
}
